import { useEffect } from 'react';
import type { AppDispatch } from '@/store';
import { clearDeferredSendErrorForChat, clearPendingMessageForChat } from '@/store';

type DeferredSendError = {
  prompt: string;
};

export function useRestorePromptAfterDeferredSendError({
  chatId,
  draftChatKey,
  deferredSendError,
  dispatch,
  setChatQuery,
}: {
  chatId: string | undefined;
  draftChatKey: string;
  deferredSendError: DeferredSendError | undefined;
  dispatch: AppDispatch;
  setChatQuery: (value: string) => void;
}) {
  useEffect(() => {
    if (!deferredSendError?.prompt) return;

    // Background deferred send failed: restore the original prompt into the input.
    setChatQuery(deferredSendError.prompt);

    const key = chatId || draftChatKey;
    dispatch(clearDeferredSendErrorForChat({ chatId: key }));
    dispatch(clearPendingMessageForChat({ chatId: key }));
  }, [chatId, deferredSendError, dispatch, draftChatKey, setChatQuery]);
}
